import type { EditorThemeClasses } from 'lexical'

export const ICONS = {
  bold: '/img/bold.svg',
  italic: '/img/italic.svg',
  underline: '/img/underline.svg',
  undo: '/img/undo.svg',
  redo: '/img/redo.svg',
  alignLeft: '/img/align-left.svg',
  alignCenter: '/img/align-center.svg',
  alignRight: '/img/align-right.svg',
  link: '/img/link.svg'
} as const

export const TEXT_ALIGNMENTS = [
  { value: 'left', icon: ICONS.alignLeft, label: 'Align left' },
  { value: 'center', icon: ICONS.alignCenter, label: 'Align center' },
  { value: 'right', icon: ICONS.alignRight, label: 'Align right' }
] as const

export const EDITOR_THEME: EditorThemeClasses = {
  paragraph: 'my-2',
  heading: {
    h1: 'text-[64px] font-semibold',
    h2: 'text-[32px] font-semibold',
    h3: 'text-2xl font-semibold',
    h4: 'text-xl font-semibold',
    h5: 'text-lg font-semibold'
  },
  quote: 'border-l-4 border-border pl-4 italic text-black/25',
  link: 'link',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through'
  }
} as const

export const FONT_SIZE = {
  min: 12,
  max: 64,
  step: 2,
  default: 16
} as const

export const BLOCK_TYPES = [
  { label: 'Normal', value: 'paragraph' },
  { label: 'Heading 1', value: 'h1' },
  { label: 'Heading 2', value: 'h2' },
  { label: 'Heading 3', value: 'h3' },
  { label: 'Heading 4', value: 'h4' },
  { label: 'Heading 5', value: 'h5' },
  { label: 'Quote', value: 'quote' }
] as const
